











































import { Vue, Component } from 'vue-property-decorator';

import contactPopup from '@/components/popup/ContactPopup.vue';
import buttonGreen from '@/components/atomic/atoms/ButtonGreen.vue';

@Component({
  name: 'ContactSection',
  components: {
    contactPopup,
    buttonGreen,
  },
})
/**
 * @vuese
 * @group Page/ContactSection
 * ContactSection component
 */
export default class ContactSection extends Vue {
  $refs!: {
    contactPopup: contactPopup
  }

  clickFAQ() {}

  clickContactUs() {
    this.$refs.contactPopup.showPopup();
  }
}
